module.exports = __webpack_public_path__ + "static/media/roboto-700.adcde98f.woff";